<ion-content>
  <ion-row class="ion-no-padding">
    <ion-col size="1">
      <ion-button (click)="goBack()" id="back" tooltip="Back" size="small">
        <ion-icon src="/assets/icons/24px/chevron-left.svg" slot="icon-only"> </ion-icon>
      </ion-button>
    </ion-col>

    <ion-col class="ion-no-padding">
      <ion-item lines="none">
        <ion-input
          [(ngModel)]="query"
          (keyup.enter)="search()"
          (keyup.escape)="goBack()"
          placeholder="Search Giphy"
          scAutoFocus>
        </ion-input>

        <ion-button aria-label="Search Gifs" (click)="search()" class="grey" size="small" tooltip="Search">
          <ion-icon src="/assets/icons/24px/search.svg" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row id="gifs">
    <ion-col *ngFor="let gif of gifs" size="4" class="ion-align-self-center">
      <ion-img (click)="select(gif)" [src]="gif.images.fixed_height.url" [alt]="gif.title"> </ion-img>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <a href="https://giphy.com" target="_blank" alt="Giphy.com">
        <ion-img
          *ngIf="(theme$ | async).includes('light')"
          src="assets/images/PoweredByGiphy-Dark.png"
          alt="Powered By Giphy"
          class="giphyBrand">
        </ion-img>

        <ion-img
          *ngIf="(theme$ | async).includes('dark')"
          src="assets/images/PoweredByGiphy.png"
          alt="Powered By Giphy"
          class="giphyBrand">
        </ion-img>
      </a>
    </ion-col>
  </ion-row>
</ion-content>
